import { SmartMetersDashboardDownloadRequest } from "@/api/backofficeRest/generated/model"
import { useMutation } from "@/api/utils/useQuery"
import { MutationResult } from "@/api/utils/types"
import { formatLocalDateTime } from "@/helpers/dateHelper"
import { ISmartMeterDownload } from "./SmartMeterMutator.types"
import { defineSelectedMeterType } from "@/views/operations/smartMeters/opsSmartMeterConfig"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"

export interface ISmartMeterMutator {
  download(): MutationResult<ISmartMeterDownload>
}

export class SmartMeterMutatorClass implements ISmartMeterMutator {
  download() {
    return useMutation({
      ...BackofficeRestMutations.smartMeter.download(),
      serializerFn: (
        data: ISmartMeterDownload,
      ): SmartMetersDashboardDownloadRequest => {
        return {
          limit: data.limit,
          offset: data.offset,
          sortColumnName: data.sortColumn,
          sortDxn: data.sortDirection,
          selectedDeviceStatuses: data.deviceStatuses ?? [],
          installationDateFrom:
            formatLocalDateTime(data.installedDateFrom) ?? undefined,
          installationDateTo:
            formatLocalDateTime(data.installedDateTo) ?? undefined,
          lastMeterReadDateFrom:
            formatLocalDateTime(data.lastReadDateFrom) ?? undefined,
          lastMeterReadDateTo:
            formatLocalDateTime(data.lastReadDateTo) ?? undefined,
          readingsReceivedFilter: data.readingsReceived,
          selectedLastOrchestrations: data.lastOrchestrations ?? [],
          selectedOrchestrationStatuses: data.orchestrationStatuses ?? [],
          selectedSrvs: data.serviceRequests ?? [],
          selectedErrors: data.errorCodes ?? [],
          selectedErrorStatuses: data.errorStatuses ?? [],
          selectedAlertCodes: data.alerts ?? [],
          selectedAlertStatuses: data.alertStatuses ?? [],
          alertDateFrom: formatLocalDateTime(data.alertDateFrom) ?? undefined,
          alertDateTo: formatLocalDateTime(data.alertDateTo) ?? undefined,
          ssdFrom: formatLocalDateTime(data.ssdFrom) ?? undefined,
          ssdTo: formatLocalDateTime(data.ssdTo) ?? undefined,
          selectedMeterType: defineSelectedMeterType(data.meterType),
          selectedFirmwareStatuses: data.firmwareStatuses ?? [],
          selectedFirmwareVersions: data.firmwareVersions ?? [],
          selectedGbcsVersions: data.gbcsVersions ?? [],
          selectedManufacturers: data.manufacturers ?? [],
          selectedModels: data.models ?? [],
          selectedRegions: data.regions ?? [],
          selectedSmetsVersions: data.smetsVersions ?? [],
          selectedPaymentModes: data.paymentModes ?? [],
          selectedVariants: data.variants ?? [],
          selectedWorkstreams: data.workstreams ?? [],
          selectedDeviceIds: data.selectedDeviceIds ?? [],
        }
      },
    })
  }
}

export const SmartMeterMutator = new SmartMeterMutatorClass()
